import {
    IonCard,
    IonCardContent,
    IonCardTitle,
    IonCol,
    IonContent,
    IonPage,
    IonRow,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import ErrorAlert from "../../../../../../components/Errors/ErrorAlert";
import Header from "../../../../../../components/Headers/Header";
import PageTitle from "../../../../../../components/PageTitle/PageTitle";
import { RouteComponentProps } from "react-router";
import { Organization } from "../../../../../../models";
import { getOrganizationById } from "../../../../../../utilities/organization/Organization";
import TaxTypeForm from "../../../../../../components/TaxRates/TaxTypeForm";

interface OrganizationPageProps extends RouteComponentProps<{
    id: string;
}> {}

const OrganizationTaxesPage: React.FC<OrganizationPageProps> = ({match}) => {
    const [organization, setOrganization] = useState<Organization>();
    const [error, setError] = useState("");

    useEffect(() => {
        async function getOrganization() {
            const queryResult = await getOrganizationById(match.params.id);
            if (queryResult.isSuccess) {
                setOrganization(queryResult.result);
            } else {
                setError("Sorry, a problem occurred. Please go back and try again.");
            }
        }

        getOrganization();
    }, [match, match.params.id]);

    return (
        <IonPage className="bg-light">
            <Header />
            <IonContent>
                <PageTitle title={organization ? organization.name : "Event Settings"} />
                <IonRow className="ion-justify-content-center">
                    {error && <ErrorAlert width="12" error={error} />}
                    <IonCol size="12">
                        <IonCard mode="md" className="ion-padding bg-white">
                            <IonCardTitle>Organization Tax Settings</IonCardTitle>
                        </IonCard>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol sizeSm="12" sizeMd="6">
                        <IonCard mode="md" className="ion-padding bg-white">
                            <IonCardTitle>Tax Types</IonCardTitle>
                            <IonCardContent>
                                {organization ? 
                                    <TaxTypeForm organization={organization} />
                                    :
                                    <p>Loading...</p>
                                }
                            </IonCardContent>
                        </IonCard>
                    </IonCol>
                </IonRow>
            </IonContent>
        </IonPage>
    );
};

export default OrganizationTaxesPage;